import api from 'api'
import { CompanyGroupDetail } from 'pages/CompanyGroupDetail/types'

export const getCompanyGroupDetail = async (
  companyGroupId: number
): Promise<CompanyGroupDetail> => {
  const response = await api.get(`/admin/company_group/${companyGroupId}`)
  return response.data
}
